<mat-chip-list
    #chipList
    selectable multiple
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid"
    (blur)="onTouched()"
>
    <div *ngFor="let option of options">
        <mat-chip 
            #listChip
            #c="matChip"
            [class]="class"
            [value]="option.value"
            (click)="select(c, option)"
        >{{option.label}}</mat-chip>
    </div>
</mat-chip-list>
<div *ngIf="!disableMessages" class="messages">
    <ng-content selector="app-form-error"></ng-content>
    <ng-content selector="app-form-success"></ng-content>
</div>